import { createElement } from 'react';
import { b as _extends } from '../_rollupPluginBabelHelpers-3b7bd988.js';
import { Div } from '@vebox/etui-system-elements';

const ValueContainer = ({
  isMulti,
  selectProps: {
    name,
    startInputAddon,
    customTheme,
    placeholder,
    size,
    customStyles
  },
  children
}) => /*#__PURE__*/createElement(Div, _extends({
  display: "flex",
  alignItems: "center",
  position: "relative",
  pt: placeholder ? `${size === 'default' ? customTheme.spacing.xlg : customTheme.spacing.lg - 2}px` : `calc(${customTheme.spacing.sm}px - 4px)`,
  pl: startInputAddon !== undefined ? `calc(40px - 1px)` : `calc(${customTheme.spacing.xs}px)`,
  pb: placeholder ? `${size === 'default' ? customTheme.spacing.xs : customTheme.spacing.xxs}px` : `${customTheme.spacing.xs}px`,
  width: "100%"
}, isMulti && {
  flex: '1 1 0%',
  flexWrap: 'wrap',
  width: '90%',
  minWidth: 0
}, customStyles.valueContainer, {
  "aria-label": name,
  "aria-labelledby": name
}), startInputAddon, children);

export default ValueContainer;
